var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rubric-version-status-badge',{attrs:{"status":_vm.params.data.status}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }